import { Reservations } from '../collections/reservations/reservations';
import { Flights } from '../collections/flights/flights';
import { Meteor } from 'meteor/meteor';
import moment from 'moment';

import { reservationsStatistics } from '../collections/statistics/reservations';
import { flightsStatistics } from '../collections/statistics/flights';
import { pilotsFlightsStatistics, pilotsHoursStatistics } from '../collections/statistics/pilots';
import { montgolfieresFlightsStatistics, montgolfieresHoursStatistics } from '../collections/statistics/montgolfieres';

export class StatistiquesHelpers {

    constructor(props) {}

    static launchStatistiques(type, from, to, affichage) {

    	return new Promise((resolve, reject) => {

			if(type == 'reservations') {
			   return resolve({
					labels: this.getLabels(from, to, affichage),
					datasets: [
						this.setDataSets('Cumulé', this.getReservations(from, to, affichage)[0], '74,135,252'),
			        	this.setDataSets('Angers', this.getReservations(from, to, affichage)[1], '75,192,192'),
			        	this.setDataSets('Nantes', this.getReservations(from, to, affichage)[2], '250, 114, 82'),
					]
				});
			}

			if(type == 'vols') {
			   return resolve({
					labels: this.getLabels(from, to, affichage),
					datasets: [
						this.setDataSets('Cumulé', this.getVols(from, to, affichage)[0], '74,135,252'),
			        	this.setDataSets('Angers', this.getVols(from, to, affichage)[1], '75,192,192'),
			        	this.setDataSets('Nantes', this.getVols(from, to, affichage)[2], '250, 114, 82'),
					]
				});
			}

			if(type == 'pilotes-vols') {

				let that = this;
				this.getPilotsVols(from, to, affichage).then(function(results) {

					let datasets = [];

					_.each(results, (data) => {
						datasets.push(that.setDataSets(data[0], data[1], data[2]));
					});

					return resolve({
						labels: that.getLabels(from, to, affichage),
						datasets: datasets
					});
				});

			}

			if(type == 'pilotes-heures') {

				let that = this;
				this.getPilotsHeures(from, to, affichage).then(function(results) {

					let datasets = [];

					_.each(results, (data) => {
						datasets.push(that.setDataSets(data[0], data[1], data[2]));
					});

					return resolve({
						labels: that.getLabels(from, to, affichage),
						datasets: datasets
					});
				});

			}

			if(type == 'montgolfieres-vols') {

				console.log('montgolfieres-vols');

				let that = this;
				this.getMontgolfieresVols(from, to, affichage).then(function(results) {

					let datasets = [];

					_.each(results, (data) => {
						datasets.push(that.setDataSets(data[0], data[1], data[2]));
					});

					return resolve({
						labels: that.getLabels(from, to, affichage),
						datasets: datasets
					});
				});

			}

			if(type == 'montgolfieres-heures') {

				let that = this;
				this.getMontgolfieresHeures(from, to, affichage).then(function(results) {

					let datasets = [];

					_.each(results, (data) => {
						datasets.push(that.setDataSets(data[0], data[1], data[2]));
					});

					return resolve({
						labels: that.getLabels(from, to, affichage),
						datasets: datasets
					});
				});

			}

		});

    }

    static getLabels(from, to, affichage) {
        let labels = [];
        if(affichage == 'months') {
            for(let i = 0; i <= moment(to).diff(moment(from), 'months'); i++) {
                let month = moment(from).add(i, 'months').format('MMMM YYYY');
                labels.push(month.charAt(0).toUpperCase() + month.slice(1));
            }
            return labels;
        } else {
            for(let i = 0; i <= moment(to).diff(moment(from), 'years'); i++)
                labels.push(moment(from).add(i, 'years').format('YYYY'));
            return labels;
        }
    }

    static setDataSets(label, data, color) {
        return {
            label: label,
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(' + color + ',0.4)',
            borderColor: 'rgba(' + color + ',1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(' + color + ',1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(' + color + ',1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: data
        }
    }

    static getVols(from, to, affichage) {
    	return flightsStatistics.call({
			from: from,
			to: to,
			affichage: affichage
		}, ((err, results) => {
			return results;
		}).bind(this));
    }

    static getReservations(from, to, affichage) {
    	return reservationsStatistics.call({
			from: from,
			to: to, 
			affichage: affichage
		}, ((err, results) => {
			return results;
		}).bind(this));
    }

    static getPilotsVols(from, to, affichage) {
    	return new Promise((resolve, reject) => {
	    	return pilotsFlightsStatistics.call({
				from: from,
				to: to,
				affichage: affichage,
			}, ((err, results) => {
				resolve(results);
			}).bind(this));
		});
    }

    static getPilotsHeures(from, to, affichage) {
    	return new Promise((resolve, reject) => {
	    	return pilotsHoursStatistics.call({
				from: from,
				to: to,
				affichage: affichage,
			}, ((err, results) => {
				resolve(results);
			}).bind(this));
		});
    }

    static getMontgolfieresVols(from, to, affichage) {
    	return new Promise((resolve, reject) => {
	    	return montgolfieresFlightsStatistics.call({
				from: from,
				to: to,
				affichage: affichage,
			}, ((err, results) => {
				resolve(results);
			}).bind(this));
		});
    }

    static getMontgolfieresHeures(from, to, affichage) {
    	return new Promise((resolve, reject) => {
	    	return montgolfieresHoursStatistics.call({
				from: from,
				to: to,
				affichage: affichage,
			}, ((err, results) => {
				resolve(results);
			}).bind(this));
		});
    }

}



/** WEBPACK FOOTER **
 ** ./src/universal/helpers/statistiquesHelpers.js
 **/